import { createContext, useContext, useMemo, useState } from "react";

const emptyProject = () => ({
  id: null,
  name: "Untitled Van Build",
  van: null,                 // { templateId, make, model, variant, year, region, interior:{...} }
  goals: {
    crew: "couple", usage: "part_time", builder: "both", budget_tier: "mid",
    priorities: ["bed", "storage", "kitchenette"], notes: "",
  },
  modules: [],
  ai: { reasoning: "", assumptions: [], tradeoffs: [], clearances: [], build_sequence: [], hero_asset_id: null, fallback: false },
});

const Ctx = createContext(null);

export function VanDesignProvider({ children }) {
  const [project, setProject] = useState(emptyProject);
  const [screen, setScreen] = useState("home"); // home|intake|goals|draft|editor|blueprint|3d
  const [photos, setPhotos] = useState([]);     // transient base64 (never persisted)

  const patch = (partial) => setProject((p) => ({ ...p, ...partial }));
  const setVan = (van) => patch({ van });
  const setGoals = (goals) => setProject((p) => ({ ...p, goals: { ...p.goals, ...goals } }));
  const setModules = (modules) => patch({ modules: typeof modules === "function" ? modules(project.modules) : modules });
  const setAI = (ai) => setProject((p) => ({ ...p, ai: { ...p.ai, ...ai } }));
  const reset = () => { setProject(emptyProject()); setPhotos([]); setScreen("home"); };
  const load = (p) => {
    setProject({ ...emptyProject(), ...p, ai: { ...emptyProject().ai, ...(p.ai || {}) } });
  };

  const value = useMemo(
    () => ({ project, setProject, patch, setVan, setGoals, setModules, setAI, reset, load, screen, setScreen, photos, setPhotos }),
    [project, screen, photos],
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useVanDesign = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error("useVanDesign must be used within VanDesignProvider");
  return v;
};
